import { BemHelper } from "@/utils/BemHelper";
import classNames from "classnames";
import React from "react";
import CtImage from "../image/CtImage";
import CtSocialMediaCard, { CtSocialMediaCardProps } from "../social-media-card/CtSocialMediaCard";
import { ThemeFontVariant } from "../types";
import { THEME_FONT_VARIANTS } from "../constants";
import { useActiveBreakpoints } from "@/utils/useActiveBreakpoints";

export type CtCriyatorCardProps = {
  numberOfBookings?: CtSocialMediaCardProps["numberOfBookings"];
  socialMediaLinks: CtSocialMediaCardProps["socialMediaLinks"];
  imageSrc?: string;
  fontVariant: ThemeFontVariant;
  name: string;
};

const bem = new BemHelper("ct-criyator-card");

const MOBILE_IMAGE_SIZE = 52;
const DESKTOP_IMAGE_SIZE = 64;

function CtCriyatorCard({
  numberOfBookings,
  socialMediaLinks,
  imageSrc,
  fontVariant,
  name,
}: CtCriyatorCardProps) {
  const { activeBreakpoints } = useActiveBreakpoints();

  return (
    <div
      className={classNames(
        bem.block(),
        bem.modifier(fontVariant || THEME_FONT_VARIANTS.FONT_VARIANT_1),
        !activeBreakpoints.md && bem.modifier("mobile"),
      )}
    >
      <header
        className={classNames(
          bem.element("header"),
          !activeBreakpoints.md && bem.modifier("mobile", "header"),
        )}
      >
        <span className={classNames(bem.element("name"))}>{name}</span>
        <hr className={classNames(bem.element("divider"))} />
      </header>
      <section
        className={classNames(
          bem.element("content"),
          !activeBreakpoints.md && bem.modifier("mobile", "content"),
        )}
      >
        {imageSrc && (
          <CtImage
            src={imageSrc}
            square
            width={activeBreakpoints.md ? DESKTOP_IMAGE_SIZE : MOBILE_IMAGE_SIZE}
            height={activeBreakpoints.md ? DESKTOP_IMAGE_SIZE : MOBILE_IMAGE_SIZE}
            disableBorder
            disablePaddings
            objectFit='cover'
          />
        )}
        <CtSocialMediaCard
          numberOfBookings={numberOfBookings}
          disablePaddings
          socialMediaLinks={socialMediaLinks}
          fontVariant={fontVariant}
        />
      </section>
    </div>
  );
}

CtCriyatorCard.defaultProps = {
  numberOfBookings: 0,
  socialMediaLinks: {},
  fontVariant: THEME_FONT_VARIANTS.FONT_VARIANT_1,
};

export default CtCriyatorCard;
